// extracted by mini-css-extract-plugin
export var alignCenter = "_bw-d";
export var bannerShown = "_bw-6";
export var buttonContent = "_bw-0";
export var cardList = "_bw-1";
export var centerContent = "_bw-2";
export var chevron = "_bw-3";
export var closePanelButton = "_bw-k";
export var conversationContextContainer = "_bw-l";
export var conversationDetailContainer = "_bw-4";
export var detailWrapper = "_bw-7";
export var dropdownButton = "_bw-e";
export var dropdownTitle = "_bw-9";
export var fullHeight = "_bw-5";
export var hidden = "_bw-a";
export var icon = "_bw-b";
export var mergeSuggestionWrapper = "_bw-m";
export var panel = "_bw-i";
export var portalButtonsWrapper = "_bw-c";
export var right = "_bw-j";
export var tableSummaryContainer = "_bw-8";
export var tableSummaryHeader = "_bw-g";
export var threeDotsButton = "_bw-f";
export var wide = "_bw-h";